import { mutate } from "swr";
import { fetchApi } from "../fetcher";
import { endpointsViews } from "../endpoints/endpointsViews";
import { ViewResponseModel } from "lib/types/views/ViewResponseModel";
import { Operation } from "fast-json-patch";

export async function patchView(
  projectId: number,
  viewId: number,
  operations: Operation[],
): Promise<ViewResponseModel> {
  const response = await fetchApi({
    url: endpointsViews.viewById(viewId),
    method: "PATCH",
    body: operations,
    headers: {
      "Content-Type": "application/json-patch+json",
    },
  });
  await mutate(endpointsViews.viewById(viewId));
  await mutate(
    (key) =>
      typeof key === "string" &&
      key.startsWith(endpointsViews.projectViews(projectId)),
  );
  return response.json() as Promise<ViewResponseModel>;
}
